import { jsx as a, jsxs as r } from "react/jsx-runtime";
import { O as n, P as g, C as d, a as l, T as m, D as c, R as u, b as x } from "./index-Bxq-rK0V.js";
import { a as y } from "./react-icons.esm-CDi78UIJ.js";
import { c as b } from "./index-CYpVUGdk.js";
import { $ as o } from "./utils-CTvPli9r.js";
import { forwardRef as i } from "react";
const F = u, H = x, V = l, N = g, p = i(({ className: e, ...t }, s) => /* @__PURE__ */ a(
  n,
  {
    className: o(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: s
  }
));
p.displayName = n.displayName;
const S = b(
  "fixed z-50 gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500 data-[state=open]:animate-in data-[state=closed]:animate-out",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), v = i(
  ({ side: e = "right", className: t, children: s, ...f }, h) => /* @__PURE__ */ r(N, { children: [
    /* @__PURE__ */ a(p, {}),
    /* @__PURE__ */ r(d, { ref: h, className: o(S({ side: e }), t), ...f, children: [
      /* @__PURE__ */ r(l, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary", children: [
        /* @__PURE__ */ a(y, { className: "size-4" }),
        /* @__PURE__ */ a("span", { className: "sr-only", children: "Close" })
      ] }),
      s
    ] })
  ] })
);
v.displayName = d.displayName;
const w = ({ className: e, ...t }) => /* @__PURE__ */ a("div", { className: o("flex flex-col space-y-2 text-center sm:text-left", e), ...t });
w.displayName = "SheetHeader";
const C = ({ className: e, ...t }) => /* @__PURE__ */ a(
  "div",
  {
    className: o("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", e),
    ...t
  }
);
C.displayName = "SheetFooter";
const T = i(({ className: e, ...t }, s) => /* @__PURE__ */ a(
  m,
  {
    ref: s,
    className: o("text-lg font-semibold text-foreground", e),
    ...t
  }
));
T.displayName = m.displayName;
const j = i(({ className: e, ...t }, s) => /* @__PURE__ */ a(
  c,
  {
    ref: s,
    className: o("text-sm text-muted-foreground", e),
    ...t
  }
));
j.displayName = c.displayName;
export {
  F as Sheet,
  V as SheetClose,
  v as SheetContent,
  j as SheetDescription,
  C as SheetFooter,
  w as SheetHeader,
  p as SheetOverlay,
  N as SheetPortal,
  T as SheetTitle,
  H as SheetTrigger
};
//# sourceMappingURL=sheet.js.map
